<template>
    <v-content class="bg-content">
      <div class="about">
        <v-container grid-list-xl style="padding: 10px; top:20px">
          <v-card dark class="theme-bg-card-2 card-animate-2">
            <v-app-bar
              color="rgba(12, 22, 27, 0.9)"
              max-height="75"
              height="75"
              elevation="3"
              dense
              dark
            >
            <v-toolbar-title>
              <v-avatar size="40">
                <img src="@/assets/CustomerIconNEW3.png" />
              </v-avatar>
              Contacts
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <div>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                dense
                outlined
                class="mr-1"
                v-on:change="searchContact"
              ></v-text-field>
            </div>

            <v-btn
              class="ma-2"
              outlined
              color="white"
              value="Go Back From Whence You Came!"
              onclick="history.back(-1)"
              >Previous Page</v-btn
            >

            <v-btn
              elevation="2"
              outlined
              dark
              depressed
              color="white"
              @click="openForm"
              >Create</v-btn
            >
          </v-app-bar>

          <v-data-table
            class="theme-bg-card-2"
            :loading="tableLoader"
            loading-text="Loading... Please wait"
            :headers="headers"
            :items="contactsList"
            :search="search"
            max-width="750"
            id="virtual-scroll-table"
            v-scroll:#virtual-scroll-table-3="onScroll"
          >
            <template v-slot:item.controls="props">
              <i
                class="fa fa-trash thrash"
                @click="deleteConfirmation(props.item)"
              ></i>
              <i
                class="fa fa-pencil thrash"
                @click="editContact(props.item)"
                style="margin-left: 20px"
              ></i>
            </template>
          </v-data-table>
        </v-card>
      </v-container>
    </div>

      <v-dialog v-model="showConfirmation" max-width="290">
        <v-card class="theme-bg-card-4">
          <v-card-title class="text-h5">
            Are you sure you want to delete this contact?
          </v-card-title>

          <v-card-text :v-if="itemToBeDeleted._id">
            Contact: {{ itemToBeDeleted.contactName }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              text
              @click="showConfirmation = false"
            >
              Disagree
            </v-btn>

            <v-btn
              color="green darken-1"
              text
              :loading="loading3"
              :disabled="loading3"
              @click="deleteContact()"
            >
              Agree
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-overlay :value="overlay" opacity="0.98" z-index="9">
        <v-card
          v-scroll.self="onScroll"
          style="background-color: rgba(48, 64, 87, 0.8)"
          class="overflow-y-auto popup-container theme-bg-card-3"
        >
          <v-layout row wrap fluid>
            <v-flex xs12 sm12 md12>
              <v-list-item class="mb-margin">
                <v-list-item-content>
                  <v-form
                    ref="contactform"
                    lazy-validation
                    aria-autocomplete="off"
                  >
                    <v-banner
                      class="justify-center text-h5 font-weight-light"
                      sticky
                    >
                      <v-avatar size="70">
                        <img src="@/assets/CustomerIconNEW3.png" />
                      </v-avatar>
                      Contacts
                    </v-banner>

                    <h6 class="display-6 font-weight-thin">
                      General Information
                    </h6>

                    <v-row>
                      <v-text-field
                        v-model="formFields.contactName"
                        class="mg-lr14"
                        label="Contact Name"
                        outlined
                        required
                      ></v-text-field>
                    </v-row>

                    <v-row>
                      <v-text-field
                        v-model="formFields.firstName"
                        class="mg-lr14"
                        label="First Name"
                        outlined
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="formFields.lastName"
                        class="mg-lr14"
                        label="Last Name"
                        outlined
                        required
                      ></v-text-field>
                    </v-row>

                    <v-row>
                      <v-text-field
                        class="mg-lr14"
                        v-model="formFields.phone"
                        label="Phone"
                        outlined
                        required
                      ></v-text-field>
                      <v-text-field
                        class="mg-lr14"
                        v-model="formFields.email"
                        label="Email"
                        outlined
                        required
                      ></v-text-field>
                    </v-row>

                    <v-row>
                      <v-text-field
                        class="mg-lr14"
                        v-model="formFields.street"
                        label="Street"
                        outlined
                        required
                      ></v-text-field>
                    </v-row>

                    <v-row>
                      <v-text-field
                        v-model="formFields.city"
                        class="mg-lr14"
                        label="City"
                        outlined
                        required
                      ></v-text-field>
                      <v-text-field
                        class="mg-lr14"
                        v-model="formFields.state"
                        label="State"
                        outlined
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="formFields.zipcode"
                        class="mg-lr14"
                        label="Zipcode"
                        outlined
                        required
                      ></v-text-field>
                    </v-row>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        class="mx-2"
                        color="red"
                        outlined
                        @click="resetForm()"
                        >Cancel</v-btn
                      >
                      <v-btn
                        class="mx-2"
                        color="green"
                        v-if="!editForm"
                        :loading="loading3"
                        :disabled="loading3"
                        outlined
                        @click="submitForm"
                        >Save</v-btn
                      >
                      <v-btn
                        class="mx-2"
                        color="green"
                        v-if="editForm"
                        :loading="loading3"
                        :disabled="loading3"
                        outlined
                        @click="updateContact"
                        >Update</v-btn
                      >
                    </v-card-actions>
                    <v-flex class="space2" />
                  </v-form>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
          </v-layout>
        </v-card>
      </v-overlay>



    </v-content>
</template>

<script>
export default {
  name: 'Repairs',
  components: {},
  data() {
    return {
      scrollInvoked: 0,
      items: [],
      contactsList: [],
      searchKey: '',
      search: '',
      optionIndex: 0,
      itemToBeDeleted: '',
      loading3: false,
      isLoading: false,
      productLoader: false,
      editForm: false,
      showConfirmation: false,
      overlay: false,
      rows: 100,
      itemsPerPage: 10,
      currentField: 0,
      tableLoader: false,
      date: new Date(),
      formFields: {
        contactOwner: '',
        firstName: '',
        lastName: '',
        contactName: '',
        phone: '',
        email: '',
        street: '',
        state: '',
        city: '',
        zipcode: '',
      },
      modal_date_picker: false,
      form_valid: true,
      headers: [
        {
          text: 'First Name',
          value: 'firstName',
          align: 'center',
          sortable: true,
          divider: true,
        },
        {
          text: 'Last Name',
          value: 'lastName',
          align: 'center',
          sortable: true,
          divider: true,
        },
        {
          text: 'Phone',
          value: 'phone',
          align: 'center',
          sortable: false,
          divider: true,
        },
        {
          text: 'Email',
          value: 'email',
          align: 'center',
          sortable: false,
          divider: true,
        },
        {
          text: '',
          value: 'controls',
          align: 'center',
          sortable: false,
          divider: true,
        },
      ],
    };
  },

  mounted() {
    this.getContactsList();
    Event.$on('openForm', () => {
      // Event.$off();
      console.log('Starting form in ' + this.$route.path);
      if (this.$route.path !== '/contacts') {
        return;
      }
      this.readOutLoud('Please fill the following details');
      setTimeout(() => {
        this.readOutLoud('Contacts First   Name');
        this.startListining();
      }, 3000);
      this.overlay = true;
    });

    Event.$on('editFromRecord', (data) => {
      if (this.$route.path !== '/contacts') {
        return;
      }
      console.log(data.msg);
      this.editContact(this.contactsList[0]);
    });

    Event.$on('searchFromRecord', (data) => {
      if (this.$route.path !== '/contacts') {
        return;
      }
      this.search = data.msg;
      this.searchContact(data.msg);
    });

    Event.$on('formDetails', (data) => {
      console.log(data);

      switch (data.msg) {
        case 'next':
          this.currentField++;
          this.navigateField();

          break;
        case 'previous':
          this.currentField--;
          this.navigateField();

          break;
        case 'submit':
          this.readOutLoud('Please verify your details');
          break;
        case 'verified':
          this.overlay = false;
          this.submitForm();
          break;
        default:
          this.fillForm(data.msg);
          break;
      }
    });
  },
  printLead: function() {
    window.print();
  },

  methods: {
    initialize() {
      this.contactList = [];
    },

    onScroll() {
      this.scrollInvoked++;
    },

    searchContact: async function() {
      console.log(this.search);
      if (!this.search) this.getContactList();

      this.isLoading = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}contact-form/search`,
        {
          method: 'POST',
          body: JSON.stringify({ searchText: this.search }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json();
      this.isLoading = false;

      console.log(json);
      this.contactsList = json.result;
    },

    getContactsList: async function() {
      this.tableLoader = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}contact-form/all`
      );
      const json = await response.json();
      console.log(json);
      this.contactsList = json.result;
      this.tableLoader = false;
    },

    submitForm: async function() {
      console.log(this.formFields);
      // console.log(this.inputs[0])

      this.loading3 = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}contact-form/create`,
        {
          method: 'POST',
          body: JSON.stringify({ ...this.formFields }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);

      setTimeout(() => {
        this.readOutLoud('Contact Created');
        this.getContactsList();
        this.resetForm();
      }, 800);
    },

    deleteConfirmation: function(item) {
      this.itemToBeDeleted = item;
      this.showConfirmation = true;
    },

    deleteContact: async function() {
      this.loading3 = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}contact-form/delete`,
        {
          method: 'POST',
          body: JSON.stringify({ id: this.itemToBeDeleted._id }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);
      this.itemToBeDeleted = '';
      this.showConfirmation = false;
      this.loading3 = false;

      setTimeout(() => {
        this.readOutLoud('1 record deleted');
        this.getContactsList();
      }, 800);
    },

    editContact: function(data) {
      this.overlay = true;
      this.editForm = true;
      this.formFields = data;
    },

    updateContact: async function() {
      this.loading3 = true;

      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}contact-form/update`,
        {
          method: 'POST',
          body: JSON.stringify(this.formFields), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);

      setTimeout(() => {
        this.readOutLoud('1 record updated');
        this.getContactsList();
        this.resetForm();
      }, 800);
    },

    resetForm: function() {
      this.overlay = false;
      this.editForm = false;
      this.loading3 = false;
      this.formFields = {
        contactOwner: '',
        firstName: '',
        lastName: '',
        contactName: '',
        phone: '',
        email: '',
        street: '',
        state: '',
        city: '',
        zipcode: '',
      };
    },

    openForm: function() {
      this.overlay = true;
      this.items = [];
    },

    startListining: function() {
      setTimeout(() => {
        Event.$emit('speakModeOn');
      }, 1000);
    },

    beforeDestroy() {
      Event.$off('speakModeOn');
      Event.$off('openForm');
      Event.$off('searchFromRecord');
      Event.$off('editFromRecord');
    },

    readOutLoud: (msg) => {
      const speech = new SpeechSynthesisUtterance();
      const voiceName = 'Google UK English Male';
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.voice = speechSynthesis.getVoices().filter(function (voice) {
      return voice.name === voiceName
    })[0]
      speech.text = msg;
      window.speechSynthesis.speak(speech);

     speech.onend = function() {
      setTimeout(() => {
      Event.$emit('speakModeOn');
      }, 3200);
     };
    },
    fillForm: function(msg) {
      switch (this.currentField) {
        case 0:
          this.formFields.firstName = msg;
          break;
        case 1:
          this.formFields.lastName = msg;
          break;
        case 2:
          this.formFields.phone = msg;
          break;
        case 3:
          this.formFields.email = msg;
          break;
        case 4:
          this.formFields.street = msg;
          break;
        case 5:
          this.formFields.city = msg;
          break;
        case 6:
          this.formFields.state = msg;
          break;
        case 7:
          this.formFields.zipcode = msg;
          break;
      }
      this.currentField++;
      this.navigateField();
    },

    navigateField: function() {
      console.log(this.currentField);
      switch (this.currentField) {
        case 0:
          this.readOutLoud('First name?');
          break;
        case 1:
          this.readOutLoud('Last name?');
          break;
        case 2:
          this.readOutLoud('Phone?');
          break;
        case 3:
          this.readOutLoud('Email?');
          break;
        case 4:
          this.readOutLoud('Street ?');
          break;
        case 5:
          this.readOutLoud('City ?');
          break;
        case 6:
          this.readOutLoud('State ?');
          break;
        case 7:
          this.readOutLoud('Zip code ?');
          break;
      }
      this.startListining();
    },
  },
};
</script>

<style scoped src="../components/css/Style.css">
@import '../components/css/Style.css';
</style>